import chatSessionsReducer from './chatSessions';

export const reducer = chatSessionsReducer;
export * from './chatSessions';